export default __webpack_public_path__ + "static/media/item1.785802b8.png";